import { render, staticRenderFns } from "./AddEducation.vue?vue&type=template&id=0443802f"
import script from "./AddEducation.vue?vue&type=script&lang=js"
export * from "./AddEducation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports